export const apiBaseURL = 'https://dlapi.beatmitra.com';
// const apiBaseURL = 'http://192.168.31.222:3005';
// const apiBaseURL = 'http://192.168.1.5:3005';
// const apiBaseURL = 'http://192.168.1.5:3005';
// const apiBaseURL = 'http://192.168.45.24:3005';
// export const apiBaseURL = 'http://192.168.1.16:3005';
// export const apiBaseURL = 'http://192.168.1.4:3005';
// export const apiBaseURL = 'http://localhost:3005';


export const URL = {
    LOGIN_IN_URL: `${apiBaseURL}/api/v1/dealer/login`,
    VERIFY_TOKEN_URL: `${apiBaseURL}/api/v1/dealer/verify-token`,
    DEALER_PRODUCT_ORDER_LIST_URL: `${apiBaseURL}/api/v1/dealer/product-order-list`,
    PLACE_ORDER_BY_DEALER_URL: `${apiBaseURL}/api/v1/dealer/place-order`,
    DEALER_INVOICE_SUMMARY_URL: `${apiBaseURL}/api/v1/dealer/invoice-summary`,
    DEALER_INVOICE_LIST_URL: `${apiBaseURL}/api/v1/dealer/invoice-list`,
    DEALER_INVOICE_DETAIL_URL: `${apiBaseURL}/api/v1/dealer/invoice-detail`,
};

export const personImageUrl = 'https://i.imghippo.com/files/Ynrz01716627559.jpg';